@switch (columnName) {
  @case ('pauseHistoryExpand__hidden') {
    <span class="pause-history-expand-cell">
      @if (element.historyVersionRows?.length) {
        <mat-icon>expand_more</mat-icon>
      }
    </span>
  }
  @case ('startAt') {
    <span class="highlighted-text">
      {{ element.startAt | date }}
    </span>
    <span class="text-secondary">
      {{ element.startAt | date: timeFormat }}
    </span>
  }
  @case ('endAt') {
    <span class="highlighted-text">
      {{ element.endAt | date }}
    </span>
    <span class="text-secondary">
      {{ element.endAt | date: timeFormat }}
    </span>
  }
  @case ('performedBy') {
    {{ element.performedBy }}
  }
  @case ('performedAt') {
    <span class="highlighted-text">
      {{ element.performedAt | date }}
    </span>
    <span class="text-secondary">
      {{ element.performedAt | date: timeFormat }}
    </span>
  }
  @case ('comment') {
    <app-text-overflow-label [text]="element.comment ?? ''"></app-text-overflow-label>
  }
  @case ('state') {
    @if (element.state != null && pauseStateLabels[element.state]; as stateLabel) {
      <app-ui-pill [name]="getPauseStatePillName(element.state)" [customLabel]="true">
        {{ stateLabel | translate }}
      </app-ui-pill>
    }
  }
  @case ('reason') {
    @if (element.reason != null && pauseReasonLabels[element.reason]; as reasonLabel) {
      {{ reasonLabel | translate }}
    }
  }
}
